import { read_u16, Sink } from "../../helpers/serializerHelpers";

export class PointCloudSideInfo {
    public snr: number = 0; //in m
    public noise: number = 0; // in rad

    public deserialize(bytes: Sink) {
        this.snr = read_u16(bytes);
        this.noise = read_u16(bytes);
        return this;
    }
    public getLength() {
        return 4;
    }
}
